import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// import { LoggedInUser } from '../model/logged-in-user';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  constructor(private http: HttpClient) { }

  reportBugURL = 'https://rzn7x22y34.execute-api.eu-west-1.amazonaws.com/operator/bug-report'

  getUserData(recUserData) {
    const StoredUserDataName = recUserData.Name;
    const StoredUserDataID = recUserData.EmployeeID;
    const StoredUserImage = recUserData.ProfileImage;

    localStorage.setItem('userName', StoredUserDataName)
    localStorage.setItem('userID', StoredUserDataID)
    localStorage.setItem('userImage', StoredUserImage)
  }

  reportBug(bugObj) {
    const header = new HttpHeaders();
    header.set('x-api-key', 'IBjCIv2N5H1bG18qkxtT94xxo9XPkRN38XIQiFs5')
    return this.http.post<any>(this.reportBugURL, bugObj, { headers: header })
  }
}
